module.exports = __webpack_public_path__ + "img/jigsaw-back-3.1603b73e.png";